import { makeStyles } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';

const whiteRadioStyles = makeStyles(() => ({
  root: {
    color: 'inherit',
    '&$checked': {
      color: 'inherit',
    },
    '&$disabled': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  checked: {},
  disabled: {},
}));

function WhiteRadio(props) {
  const classes = whiteRadioStyles();

  // oxlint-disable-next-line react/jsx-props-no-spreading
  return <Radio classes={classes} {...props} />;
}

export default WhiteRadio;
